var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-secondary"},[_c('div',{staticClass:"container"},[_c('b-navbar',{staticClass:"px-md-0",attrs:{"toggleable":"lg","type":"dark","variant":"secondary"}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }